import React, { useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { PackageContextProvider, usePackage } from "contexts/PackageContext";
import { BookLayoutContextProvider } from "contexts/BookLayoutContext";
import Model from "components/Model/Model";
import { useWindowWidth } from "@react-hook/window-size";
import ModelMobile from "components/Model/ModelMobile";
import axios from 'axios';

const PackageModelWrapper = () => {
    const location = useLocation();
    const { code } = useParams();

    return (
        <BookLayoutContextProvider>
            <PackageContextProvider packageCode={code} pack={location.state}>
                <PackageModel />
            </PackageContextProvider>
        </BookLayoutContextProvider>
    );
};

const PackageModel = () => {
    const { currentPack, packageCode } = usePackage();
    const width = useWindowWidth();

    const { modelId } = useParams();

    // call API to track log of the view
    const trackLog = async (model) => {
        await axios.post(`/PackageRecipientLogTrace/RecipientLooksAtModel`, {
            ModelId: model.ModelID,
            RecipientCode: packageCode,
        });
    }

    useEffect(() => {
        if (currentPack && modelId) {
            const model = currentPack.Models.find(m => m.ID === Number(modelId));
            if (model) {
                trackLog(model);
            }
        }
    }, [currentPack, modelId])

    if (!currentPack || !currentPack.Models || !currentPack.Models.length) {
        return <div />;
    }
    if (width > 900) {
        return <Model models={currentPack.Models} />;
    } else {
        return <ModelMobile models={currentPack.Models} />;
    }
};

export default PackageModelWrapper;
